import React, { useState, useContext } from "react";
import TextArea from "../../../components/TextArea";
import { TextField } from "@mui/material";

const InputOnSubmit = ({
  data,
  cab,
  hijos,
  campokey,
  indiceData,
  type = cab.type,
  id_elemento,
}) => {
  const [value, setValue] = useState(data[campokey]);
  const [lastValue, setLastvalue] = useState(data[campokey]);

  const label = (() => {
    if (cab.label_alias) {
      return data[cab.label_alias];
    }
    const _label = data[cab.id_a + "_label"] ?? cab.label;
    if (!_label || _label === "") return null;
    return _label;
  })();
  const nombre = (() => {
    if (cab.nombre_alias) {
      return data[cab.nombre_alias];
    }
    const _nombre = data[cab.id_a + "_nombre"] ?? cab.nombre;
    if (!_nombre || _nombre === "") return null;
    return _nombre;
  })();

  const clave_envio = (() => {
    if (
      data[cab.id_a + "_clave_envio"] &&
      data[cab.id_a + "_clave_envio"] !== ""
    )
      return data[cab.id_a + "_clave_envio"];
    if (cab.clave_envio && cab.clave_envio !== "") return cab.clave_envio;
    return cab.id_a;
  })();

  const handleCancelar = () => {
    setValue(data[campokey]);
    setLastvalue(data[campokey]);
  };

  const handleChange = async (e) => {
    try {
      const valor = e.target.value;

      if (valor === null || lastValue?.toString() === valor.toString().trim())
        return;

      // setLastvalue(() => value);
      data[clave_envio] = valor;
      setValue(() => valor);
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  const style = (() => {
    if (data[cab.update_id_alias]) {
      return {
        textAlign: cab.align ?? "left",
        borderColor: "darkgreen",
        borderWidth: "2px",
        fontSize: "0.8rem",
      };
    }
    return {
      textAlign: cab.align ?? "left",
      borderColor: "grey",
      fontSize: "0.8rem",
    };
  })();

  let Componente = (
    <TextArea
      value={value ?? ""}
      setValue={setValue}
      onEnter={handleChange}
      style={style}
      id={id_elemento}
    />
  );

  if (type === "number") {
    Componente = (
      <TextField
        id={id_elemento}
        type="number"
        onChange={handleChange}
        value={value}
        defaultValue={value}
        inputProps={{
          style: { textAlign: "right", fontSize: "1em", padding: "0.2em" },
        }}
        className="Mui-Root-width-webkit"
        variant="outlined"
      />
    );
  }

  if (type === "textarea") {
    Componente = (
      <TextArea
        value={value ?? ""}
        setValue={setValue}
        onEnter={handleChange}
        style={style}
        id={id_elemento}
      />
    );
  }

  if (!type || type === "text") {
    Componente = (
      <TextField
        id={id_elemento}
        type="text"
        onChange={handleChange}
        defaultValue={value}
        inputProps={{
          style: {
            textAlign: "center",
            fontSize: "1em",
            padding: "0.2em",
          },
        }}
        variant="outlined"
      />
    );
  }

  return (
    <div className="tarjeta_grid_item_label_item d-flex listado_boton_inputOnSubmit">
      {!!nombre ? (
        <>
          <div className="vista_label p-0">{nombre}:</div>
        </>
      ) : (
        <></>
      )}
      {Componente}
    </div>
  );
};

export default InputOnSubmit;
